import { HttpClient, HttpParams } from "@angular/common/http";
import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { CORE_ROUTES } from "@core/constants/routes.constant";
import { ProjectGuardValidation } from "@features/project/types/project-guard-validation.type";
import { ProjectOverviewData } from "@features/project/types/project-overview-data";
import { ApiCollectionResponse } from "@shared/types/api-collection-response";
import { catchError, map, Observable, of } from "rxjs";

function getProjectGuardValidation (): Observable<ProjectGuardValidation> {
  const httpClient: HttpClient = inject(HttpClient);
  const params: HttpParams = new HttpParams()
    .set("distinct", "true")
    .set("fields", "number")
    .set("limit", "2")
    .set("offset", "0");

  return httpClient.get<ApiCollectionResponse<ProjectOverviewData>>("api/projects", { params }).pipe(
    map((resp: ApiCollectionResponse<ProjectOverviewData> | undefined) => {
      const projects: ProjectOverviewData[] | undefined = resp?.data;

      if (projects?.length === 1)
      // eslint-disable-next-line @tseslint/no-non-null-assertion
        return { hasOnlyOneProject: true, projectNumber: projects[ 0 ]!.number };

      return { hasOnlyOneProject: false };
    })
  );
}

/**
 * Determines whether the user can view more than two projects before activating the route.
 * @returns A boolean indicating whether the route can be accessed.
 */
export const canActivateProjectOverview: CanActivateFn = () => {
  const router: Router = inject(Router);

  /*
   * Todo use redirection-command instead of navigation --> not possible because /:projectNumber is in Sencha?
   * Const redirectionPath: UrlTree = router.parseUrl(`/${ validation.projectNumber }`);
   */

  /*
   * Return new RedirectCommand(redirectionPath, {
   *   skipLocationChange: true
   * });
   */

  return getProjectGuardValidation().pipe(map((validation: ProjectGuardValidation) => {
    if (validation.hasOnlyOneProject) {
      void router.navigateByUrl(`${ CORE_ROUTES.PROJECTS }/${ validation.projectNumber }`);

      return false;
    }

    return true;
  }), catchError(() => of(true)));
};
